import {SpaceProto} from "../space-proto";
import ProjectSession from "../../project/project-session";
import {ProjectsTreeSortType} from "../@types";


export default function space_setSorting(space:SpaceProto, projectsSorting: ProjectsTreeSortType) {

    // save for user
    if (!gd.user.settings.navigation.spacesPreferences[space.id]) gd.user.settings.navigation.spacesPreferences[space.id] = {}
    gd.user.settings.navigation.spacesPreferences[space.id].projectsSorting = projectsSorting
    gd.user.settings.save()

    if (space.isWorkspace || space.isSection) {
        // console.log("I am Workspace or Section")

        // @ts-ignore
        const project: ProjectSession = space.project

        if (project.acl.hasFullAccess) {
            project.properties.defaultSorting = projectsSorting
            project.save()
        }

    }


}